export const roles = {
  // is_viewer: "is_viewer",
  // is_controller: "is_controller",
  // is_calculator: "is_calculator",
  // is_supporter: "is_supporter",
  cancel_advertisement: "cancel_advertisement",
  chatroom_watcher: "chatroom_watcher",
  done_advertisement: "done_advertisement",
  history_read: "history_read",
  maintainer: "maintainer",
  payment_maker: "payment_maker",
  user_manager: "user_manager",
};
